import script from "./FuturesTradeView.vue?vue&type=script&setup=true&lang=js"
export * from "./FuturesTradeView.vue?vue&type=script&setup=true&lang=js"

import "./FuturesTradeView.vue?vue&type=style&index=0&id=2c2543fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c2543fa"]])

export default __exports__